import { create } from 'zustand';
import { IClient } from '../interfaces/IUser';

interface ClientStoreState {
  clients: IClient[];
  loading: boolean;
  error: string | null;
  setClients: (clients: IClient[]) => void;
  addClient: (client: IClient) => void;
  updateClient: (id: string, client: Partial<IClient>) => void;
  removeClient: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useClientStore = create<ClientStoreState>((set) => ({
  clients: [],
  loading: false,
  error: null,
  setClients: (clients) => set({ clients }),
  addClient: (client) => set((state) => ({ clients: [...state.clients, client] })),
  updateClient: (id, updatedClient) =>
    set((state) => ({
      clients: state.clients.map((c) => (c.id === id ? { ...c, ...updatedClient } : c)),
    })),
  removeClient: (id) =>
    set((state) => ({
      clients: state.clients.filter((c) => c.id !== id),
    })),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
